import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, " File Format ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-subtitle1" }, "Options", -1)
const _hoisted_3 = { class: "q-mt-md" }
const _hoisted_4 = { class: "q-mt-md" }
const _hoisted_5 = { class: "q-mt-md" }
const _hoisted_6 = { class: "q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: "Download Report",
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Download",
        color: "primary",
        task: _ctx.task,
        onClick: _ctx.download
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_q_radio, {
        val: "pdf",
        modelValue: _ctx.format,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.format) = $event)),
        label: "PDF"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_radio, {
        val: "docx",
        modelValue: _ctx.format,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.format) = $event)),
        label: "Word"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_separator, { class: "q-mt-md" }),
      _hoisted_2,
      _createVNode(_component_q_checkbox, {
        "model-value": _ctx.formatOptions.branding,
        label: "Add references to Private Footprint",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formatOptions.branding = $event))
      }, null, 8, ["model-value"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.formatOptions.index,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formatOptions.index) = $event)),
          label: "Add Social Media Post Index"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.formatOptions.internalNotes,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formatOptions.internalNotes) = $event)),
          label: "Add internal notes"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.formatOptions.externalComments,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formatOptions.externalComments) = $event)),
          label: "Add external comments"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_q_checkbox, {
          modelValue: _ctx.formatOptions.footer,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formatOptions.footer) = $event)),
          label: "Add page footer"
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 512))
}